import { gql } from '@apollo/client';
import { StudentProfile } from '../../types/student';

export interface GetStudentProfileVariables {
    classID: string;
}

export interface GetStudentProfileResponse {
    studentProfiles: StudentProfile[];
}

export const GET_STUDENT_PROFILE = gql`
    query StudentProfiles($classID: ID!) {
        studentProfiles(where: { class: { id: { equals: $classID } }, NOT: [{ user: null }] }) {
            id
            user {
                id
            }
            givenName
            familyName
            studentNumber
            profilePic {
                url
            }
        }
    }
`;
